import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Connexion } from './Pages/connexion/connexion';
import { MainPage } from './Pages/mainPage/mainPage';
import { Header } from './components/header/header';
import { useEffect, useState } from 'react';
import { Planning } from './Pages/planning/planning';
import { PlanningWeek } from './Pages/planning/planningWeek';
import { loadCredentials } from './functions/localStorage/recupStorage';
import { useConf } from './context/account/paramsAccount';
import { RetourPresta } from './Pages/retourPresta/retourPresta';
import { Reglages } from './Pages/reglages/reglages';
import { IntlProvider } from 'react-intl';
import { AffichePresta } from './Pages/retourPresta/affichagePresta';
import { ModeHorsLigne } from './Pages/modeHorsLigne/modeHorsLigne';
import { Nav } from './components/nav/nav';
import { PlanninDays } from './Pages/planning/planningDays';
import MajModal from './components/modal/modalMaj';
import MentionsLegales from './Pages/mentionslegales';
import { Storage } from "@capacitor/storage";



const messages: { [key: string]: any } = {
  en: require('./locales/en.json'),
  fr: require('./locales/fr.json')
};

export const debugStorage = async () => {
  const keysResult = await Storage.keys();
  const keys = keysResult.keys;



  const allValues = await Promise.all(
    keys.map(async (key: any) => {
      const valueResult = await Storage.get({ key });
      let value: any;
      try {
        value = JSON.parse(valueResult.value ?? "");
      } catch (e) {
        value = valueResult.value;
      }

      return { key, value };
    })
  );
};
function App() {
  const [locale, setLocale] = useState('fr');
  const { conf, setConf }: any = useConf()
  const [modalUser, setModalUser] = useState(false)
  const [majModal, setMajModal] = useState(false)


  const checkAndRequestPermission = async () => {
    await debugStorage()

    const credentials = await loadCredentials(conf);
    if (credentials) {
      setConf({
        ...credentials,
      });
    }
  };

  useEffect(() => {
    checkAndRequestPermission();
  }, []);
  // useEffect(() => {
  //   if (!Capacitor.isNativePlatform()) {
  //     return;
  //   }
  //   fetch(`${ip}/api/version/${appName}`)
  //     .then(response => response.json())
  //     .then(data => {
  //       const versionInstallee = "1.0.0";
  //       if (data.version > versionInstallee) {
  //         setMajModal(true)
  //       } else {
  //         console.log("Vous avez déjà la dernière version.");
  //       }
  //     })
  //     .catch(error => {
  //       console.error("Erreur lors de la récupération de la version:", error);
  //     });
  // }, [isFirstLaunch])


  // useEffect(() => {
  //   const checkAndRequestPermission = async () => {
  //     const { requested, granted } = await checkStoragePermission();
  //     if (!requested || granted) {

  //       await Storage.set({ key: PERMISSION_REQUESTED_KEY, value: 'true' });
  //     }
  //   };
  //   checkAndRequestPermission();
  // }, []);
  useEffect(() => {
    const browserLanguage = navigator.language.split('-')[0];
    const storedLanguage = localStorage.getItem('appLanguage');
    setLocale(storedLanguage || browserLanguage || 'en');
  }, []);
  const handleActivateMaj = async () => {
    // await Browser.open({ url: `${ip}/download/${appName}` });
  };
  const handleDesactivateMaj = async () => {
    setMajModal(false)

  };
  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <div className="App">
        <header className="App-header">
          <Header handleModalUser={{ setModalUser, modalUser }}></Header>
        </header>
        <div className='body'>
          <Routes>
            <Route path='/mentions-legales' element={<MentionsLegales />} />
            <Route path="/planning" element={<Planning />}></Route>
            <Route path="/"
              element={
                conf?.user?.isConnected === true || conf?.ifOffLineMode === true ? (
                  conf.user?.site?.sit_id === undefined || conf.user?.site?.sit_id === null ? <Reglages /> : <MainPage />
                ) : (

                  <Connexion />

                )
              }
            />
            <Route path='/parametre' element={<Reglages />} />
            <Route path="/affiche-presta/" element={<AffichePresta />} />
            <Route path="/planning/semaine" element={<PlanningWeek />} />
            <Route path="/retour-prestation/:id" element={<RetourPresta />} />
            <Route path="/mode-hors-ligne" element={<ModeHorsLigne />} />
            <Route path='/planning/jour' element={<PlanninDays />} />
            <Route path='/mentions-legales' element={<MentionsLegales />} />
          </Routes>
          {
            conf?.user?.isConnected === true || conf?.ifOffLineMode === true ?
              <Nav></Nav> : ''
          }
        </div>
        {
          majModal === true ?
            < MajModal message="Une nouvelle version est disponible. Mettez à jour pour continuer." handleActivateMaj={() => { handleActivateMaj() }} handleDesactivateMaj={() => { handleDesactivateMaj() }}></MajModal>
            : ""
        }
      </div>
      {/* <Footer></Footer> */}
    </IntlProvider >
  );
}

export default App;
